<template>
  <div class="container">
    <!-- 无信息 -->
    <van-empty description="提交成功" v-if="this.connectStatus === '3'" />
    <!-- 接口返回错误提示 -->
    <van-empty
      image="error"
      description="错误信息"
      v-if="this.connectStatus === '1'"
    />
    <!-- 接口连接错误提示 -->
    <van-empty
      image="network"
      description="接口异常"
      v-if="this.connectStatus === '2'"
    />
    <!-- 正确显示 -->
    <van-form v-if="this.connectStatus === '0'">
      <van-cell-group>
        <van-field
          v-model="this.appraisalResultForm.kindName"
          type="text"
          label="品类"
          required
          clearable
          :disabled="true"
          center
        >
          <template #button>
            <van-button
              type="info"
              size="mini"
              @click="getAppraisalOrderDetailInfo"
              >刷新订单</van-button
            >
          </template>
        </van-field>
        <van-field
          v-model="this.appraisalResultForm.brandName"
          type="text"
          label="品牌"
          required
          clearable
          :disabled="true"
        />
        <van-field
          v-if="aiResFiled"
          v-model="aiResFiled"
          type="text"
          label="AI鉴定"
          required
          :disabled="true"
        />
        <van-image
          width="100%"
          height="300px"
          fit="contain"
          :src="appraisalResultForm.image"
          @click="showImage(appraisalResultForm.image)"
        />
      </van-cell-group>
      <div
        v-for="(item, index) in this.appraisalResultForm.appraisalDesc"
        :key="index"
      >
        <van-divider
          content-position="left"
          :style="{
            background: '#f7f8fa',
            borderColor: '#1989fa',
            color: '#000',
            marginTop: '40px',
            marginBottom: '10px',
          }"
          >{{ item.pointname }}
          <template v-if="item.grade">&nbsp;&nbsp;&nbsp; AI鉴定分数:{{item.grade}}</template>
          </van-divider
        >
        <van-image
          width="100%"
          height="300px"
          fit="contain"
          :src="item.image"
          @click="showImage(item.image)"
        />
      </div>
      <van-divider
        content-position="left"
        :style="{
          background: '#f7f8fa',
          borderColor: '#1989fa',
          color: '#000',
        }"
        >最终结果</van-divider
      >
      <div class="edit-area" :class="[isEdit?'':'disabled']">
        <van-field
          required
          readonly
          label="鉴定结果"
          v-model="appraisalResultEnum[this.appraisalResultForm.appraisalResult]"
          placeholder="请选择鉴定结果"
          @click="showAppraisarResultPicker=true"
        />

        <van-field v-model="suggestion" label="鉴定评价" type="textarea" placeholder="请填写鉴定评价，如需用户补图，请填写待补图信息" />
      </div>

      <van-popup v-model="showAppraisarResultPicker" round position="bottom">
        <van-picker
          show-toolbar
          :columns="this.appraisalResultForm.h5source===7?appraisalResultOptionsBTAS:appraisalResultOptions"
          value-key="value"
          @cancel="showAppraisarResultPicker = false"
          @confirm="onAppraisarResultPickerConfirm"
        />
      </van-popup>
      <div style="margin: 16px;">
        <van-button
          v-if="isEdit"
          round
          block
          type="info"
          native-type="submit"
          :disabled="!isEditChangeFormData"
          @click="submitBtnClick"
          >提交</van-button
        >
        <van-button
          v-else
          round
          block
          type="info"
          style="background-color:black;border-color:black"
          native-type="submit"
          @click="isEdit=true"
          >修改</van-button
        >
      </div>
    </van-form>
  </div>
</template>
<script>
import { Toast, ImagePreview } from "vant";
import {
  apiGetAppraisalOrderDetailInfo,
  apiSubmitAppraisalResult,
} from "@/common/api/appraisal.js";
export default {
  name: "orderDetail",
  data() {
    return {
      connectStatus: "0", //数据连接状况，默认为0，正常连接 , 1:接口返回错误信息，2：接口连接异常, 3:鉴定提交成功
      showPicker: false, //选择评价框
      showAppraisarResultPicker: false, //选择鉴定结果框
      index: "", //鉴定点索引
      appraisalResultForm: {}, //鉴定结果表单
      isEdit: false, //是否可以编辑，默认为false
      //鉴定结果选项
      suggestion: '',
      appraisalResultOptions: [
        {
          id: 1,
          value: "待鉴定",
        },
        {
          id: 2,
          value: "符合正品工艺",
        },
        {
          id: 3,
          value: "不符合正品工艺",
        },
        {
          id: 4,
          value: "无法鉴定",
        },
      ],
			//鉴定结果选项-BTAS
			appraisalResultOptionsBTAS: [
        {
          id: 1,
          value: "待鉴定",
        },
        {
          id: 2,
          value: "符合正品工艺",
        },
        {
          id: 3,
          value: "不符合正品工艺",
        },
        {
          id: 4,
          value: "无法鉴定",
        },
        {
          id: 5,
          value: "待补图",
        },
      ],
      aiGenuine: {
        '0': '不符合正品工艺',
        '1': '符合正品工艺',
        '2': '无法鉴定',
      },
      //鉴定结果枚举
      appraisalResultEnum: {
        1: "待鉴定",
        2: "符合正品工艺",
        3: "不符合正品工艺",
        4: "无法鉴别",
        5: "待补图",
      },

      // 复核单 ai 鉴定信息，待复核
      aiOrderDetailInfo: null,
      editCacheForm: {
        suggestion: '',
        result: ''
      },
    };
  },
  computed: {
    isBtas () {
      return this.appraisalResultForm && this.appraisalResultForm.h5source === 7
    },
    isEditChangeFormData () {
      const isChangeResult = this.appraisalResultForm.appraisalResult !== this.editCacheForm.result
      const isChangeSuggestion = this.suggestion !== this.editCacheForm.suggestion
      return isChangeResult || isChangeSuggestion
    },
    aiResFiled () {
      let message = ''
      // 
      if (this.aiOrderDetailInfo) {
        message = `${this.aiGenuine[this.aiOrderDetailInfo.genuine]}(${this.aiOrderDetailInfo.grade}分)`
      }
      return message
    }
  },
  created() {
    this.getAppraisalOrderDetailInfo();
    this.setEditCache()
  },
  methods: {
    setEditCache ({suggestion = '', result = ''} = {}) {
      this.editCacheForm = {
        suggestion,
        result
      }
    },
    //获取鉴定订单详情信息
    getAppraisalOrderDetailInfo() {
      let params = {
        moaid: this.$route.query.moaid,
      };
      apiGetAppraisalOrderDetailInfo(params)
        .then((res) => {
          if (res.errorMsg === "Success") {
            this.connectStatus = "0";
            if (res.aiOrderDetailInfo) {
              this.aiOrderDetailInfo = res.aiOrderDetailInfo
            }
            this.appraisalResultForm = {
              appraisalResult: res.appraiserDetailInfo.appraisalResult,
              kindName: res.appraiserDetailInfo.kindName,
              brandName: res.appraiserDetailInfo.brandName || "-",
              image: res.appraiserDetailInfo.image || "",
              appraisalType: res.appraiserDetailInfo.appraisalType || "", // 鉴定类型 1:纯人工 2:AI+人工
							h5source:res.appraiserDetailInfo.h5source || "",  //鉴定来源，7:BTAS
            };
            this.suggestion = res.appraiserDetailInfo.suggestion
            this.appraisalResultForm.appraisalDesc = res.appraiserDetailInfo.appraisalDesc.map(
              (item) => ({
                image: item.image,
                grade: item.grade || "",
                pointId: item.pointId,
                pointname: item.pointname,
                commentId: item.commentId,
                comment: item.comment,
                commentList: item.commentList,
              })
            );
            //过滤外观鉴定点
            this.appraisalResultForm.appraisalDesc = this.appraisalResultForm.appraisalDesc.filter(
              (item) => item.pointname !== "外观"
            );
            //如果鉴定结果为待鉴定，则鉴定单可以编辑,否则不可编辑
            if (res.appraiserDetailInfo.appraisalResult === 1) { // 待鉴定
              this.isEdit = true;
            } else {
              this.isEdit = false;
            }
            this.setEditCache({ suggestion: res.appraiserDetailInfo.suggestion, result: this.appraisalResultForm.appraisalResult})
          } else {
            this.connectStatus = "1";
          }
        })
        .catch((err) => {
          this.connectStatus = "2";
        });
    },

    //打分范围0-100格式化
    gradeScopeLimit(value) {
      let patrn = /^([1-9]\d*)(\.\d*[1-9])?$/;
      if (value === "0" || value === "") {
        return value;
      } else {
        if (value > 100 || !patrn.exec(value)) {
          Toast.fail({ duration: 1000, message: "请输入0-100的整数" });
          return "";
        } else {
          return value;
        }
      }
    },

    //选择鉴定结果确认
    onAppraisarResultPickerConfirm(data) {
      this.appraisalResultForm.appraisalResult = data.id;
      this.showAppraisarResultPicker = false;
    },
    //提交按钮点击
    submitBtnClick() {
			//如果是纯人工，就自动计算分数
			if(this.appraisalResultForm.appraisalType===1){
				this.autoCreateGrand();
			}
      this.submitAppraisalResult();
    },
    //自动生成分数
    autoCreateGrand() {
      switch (this.appraisalResultForm.appraisalResult) {
        // 1待鉴定 2符合正品工艺 3不符合正品工艺 4无法鉴定
        case 1:
          Toast.fail({ duration: 1000, message: "鉴定结果不能为待鉴定" });
          return;
          break;
        case 2:
          this.appraisalResultForm.appraisalDesc.forEach((item, index) => {
            item.grade = Math.round(Math.random() * 20) + 60; // 60-80
            item.comment =
              item.pointname +
              ((this.appraisalResultForm.appraisalDesc[index].commentList[0]||{})
                .comment || "鉴定点符合度较高");
            item.commentId = (this.appraisalResultForm.appraisalDesc[
              index
            ].commentList[0]||{}).commentId;
          });
          break;
        case 3:
          this.appraisalResultForm.appraisalDesc.forEach((item, index) => {
            item.grade = Math.round(Math.random() * 40) + 10; // 10-50
            item.comment =
              item.pointname +
              ((this.appraisalResultForm.appraisalDesc[index].commentList[1]||{})
                .comment || "鉴定点符合度较低");
            item.commentId = (this.appraisalResultForm.appraisalDesc[
              index
            ].commentList[1]||[]).commentId;
          });
          break;
        case 4:
          this.appraisalResultForm.appraisalDesc.forEach((item, index) => {
            item.grade = Math.ceil(Math.random() * 9); // 1-10
            item.comment =
              (this.appraisalResultForm.appraisalDesc[index].commentList[2]||{})
                .comment || "图片未检测到鉴定点";
            item.commentId = (this.appraisalResultForm.appraisalDesc[
              index
            ].commentList[2]||{}).commentId;
          });
          break;
        case 5:
          break;
        default:
          Toast.fail({ duration: 1000, message: "订单状态错误" });
          break;
      }
    },
    //提交鉴定表单
    submitAppraisalResult() {
      if (this.appraisalResultForm.appraisalResult === 1) {
        return Toast.fail({ duration: 1000, message: '鉴定结果不能为待鉴定' });
      }
      if (this.appraisalResultForm.appraisalResult === 5) { // 待补图
        if (!this.suggestion) {
          return Toast.fail({ duration: 1000, message: '请输入鉴定评价' });
        }
      }
      this.appraisalResultForm.suggestion = this.suggestion
      let params = {
        moaid: this.$route.query.moaid,
        appraiserDetailInfo: this.appraisalResultForm,
      };
      apiSubmitAppraisalResult(params).then((res) => {
        if (res.errorMsg === "Success") {
          this.connectStatus = "3";
        } else {
          Toast.fail({ duration: 1000, message: res.errorMsg });
        }
      });
    },

    // 图片放大查看
    showImage(imgUrl) {
      ImagePreview({
        images: [imgUrl],
        closeable: true,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background-color: #f7f8fa;
  justify-content: center;
}
.detail-form {
  width: 80%;
  height: 20%;
  border: 1px solid rgba(0, 0, 0, 0.3);
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
  padding: 50px;
}
.appraiser-name {
  width: 100%;
  height: 6vh;
}
.login-btn {
  margin-top: 40px;
  width: 100%;
  height: 6vh;
}
.edit-area {
  position: relative;
  &.disabled {
    &::after {
      position: absolute;
      content: "";
      z-index: 10;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
